import { useRouter } from 'next/compat/router';
import { useCallback } from 'react';
import { useClearRefinements } from 'react-instantsearch';

import { useProductListContext } from '~/utilities/context/static/ProductListContext';

export const useClearAllAppliedFacets = (): (() => Promise<void>) => {
  const router = useRouter();
  const { categoryDetails } = useProductListContext();
  const { refine, canRefine } = useClearRefinements();
  const { clearAllUrl, selectedFacetsV2: appliedSOLRFacets } = categoryDetails || {};

  return useCallback(async () => {
    if (appliedSOLRFacets?.length && clearAllUrl && router) {
      await router.push(clearAllUrl, undefined, { scroll: false });

      return;
    }

    if (canRefine) {
      refine();
    }
  }, [appliedSOLRFacets?.length, canRefine, clearAllUrl, refine, router]);
};
